module.exports = __webpack_public_path__ + "src/assets/images/volums/wind_speed/volum_circle8.png?8276e2d5d917d88c80969010e4bb4d65";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/wind_speed/volum_circle8.png
// module id = 841
// module chunks = 0